

















import { defineComponent } from '@vue/composition-api'
import Heading from '../components/Heading.vue'

export default defineComponent({
  components: {
    Heading,
  },
  setup(props, { root }) {
    return {
      goToCreateForm: () => root.$router.push({ name: 'home.create' }),
    }
  },
})
